import {Action} from '@ngrx/store';
import {Hub, HubId} from '../../shared/models/hub';
import {HubStatus} from '../../shared/models/hub-status';

export const HUB_TUNNEL_CHECK = '[Hubs] tunnel check fetch complete';
export const HUB_FETCHED = '[Hubs] fetched hub';
export const HUBS_USER_FETCHED = '[Hubs] fetched user hubs';
export const HUB_SAVED_TO_API = '[Hubs] saved hub to API';

export class HubTunnelCheckAction implements Action {
  readonly type = HUB_TUNNEL_CHECK;


  constructor(public hubId: HubId, public status: HubStatus) {
  }
}

export class HubFetchedAction implements Action {
  readonly type = HUB_FETCHED;


  constructor(public hub: Hub) {
  }
}

export class HubsUserFetchedAction implements Action {
  readonly type = HUBS_USER_FETCHED;


  constructor(public hubs: Hub[]) {
  }
}

export class HubSavedToApiAction implements Action {
  readonly type = HUB_SAVED_TO_API;


  constructor(public hub: Hub) {
  }
}

export type Actions =
  HubFetchedAction |
  HubTunnelCheckAction |
  HubsUserFetchedAction |
  HubSavedToApiAction;
